export const PLACEMENT = 'upload-quote-model-revision-modal'
export const WAIT_TIME = 500
export const MAX_LIMIT = 300
export const PLACEHOLDER = 'e.g revision to address wall thickness issue'
